export function ConvertOIDValueToString(objectOID, value) {
  const enumDataStr = localStorage.getItem("enumData");
  const enumData = enumDataStr ? JSON.parse(enumDataStr) : [];

  var returnStr = "";

  if (value === null || value === undefined) {
    returnStr = null;
    return returnStr;
  }
  const currentLang = (localStorage.getItem("i18nextLng") || "tr").split("-")[0];

  switch (objectOID.Type) {
    case 1:
      var oidEnum = Array.isArray(enumData)
        ? enumData.find((item) => String(item.idEnum) === String(value))
        : undefined;
      if (oidEnum) {
        if (currentLang === "tr") {
          returnStr = oidEnum.name1;
        } else if (currentLang === "de") {
          returnStr = oidEnum.name3;
        } else {
          returnStr = oidEnum.name2;
        }
      } else {
        returnStr = "UNKNOWN";
      }
      break;

    case 0: // BOOL
      returnStr = value === "1" || value === 1 ? "TRUE" : "FALSE";
      break;

    case 2: // INTEGER
    case 3: // SHORT_STRING
    case 4: // IP
    case 6: // LONG_STRING
    case 7: // HOST
    case 8: // SEKIZBIT
    case 9: // ONALTINBIT
      returnStr = value.toString();
      break;

    case 5: // FLOAT
      let floatVal = parseFloat(value);
      returnStr = !isNaN(floatVal) ? floatVal.toString() : "-999.0";
      break;

    case 10: // (INT1000)
      let intBinResult = -999.0;
      if (!isNaN(parseInt(value))) {
        intBinResult = parseInt(value);
        returnStr = (intBinResult / 1000.0).toString();
      } else {
        returnStr = intBinResult.toString();
      }
      break;

    case 11: // (INT100)
      let intYuzResult = -999.0;
      if (!isNaN(parseInt(value))) {
        intYuzResult = parseInt(value);
        returnStr = (intYuzResult / 100.0).toString();
      } else {
        returnStr = intYuzResult.toString();
      }
      break;

    case 12: // (INT10)
      let intOnResult = -999.0;
      if (!isNaN(parseInt(value))) {
        intOnResult = parseInt(value);
        returnStr = (intOnResult / 10.0).toString();
      } else {
        returnStr = intOnResult.toString();
      }
      break;

    default:
      returnStr = value.toString();
      break;
  }

  return returnStr;
}

export default ConvertOIDValueToString;
